import { useEffect } from 'react'

import PlainButton from 'app/common/ui-next/plain-button'
import ControlsBar from 'app/common/ui-next/controls-bar'

import { filterActions, useFilterDirty, useFilterReady, useFilterVisibility } from '../filterStore'

import { OrgControl } from './controls/OrgControl'
import { OrgTypeControl } from './controls/OrgTypeControl'
import { BuildingControl } from './controls/BuildingControl'
import { SalePointControl } from './controls/SalePointControl'
// import { SchoolYearControl } from './controls/SchoolYearControl'
import { PeriodControl } from './controls/PeriodControl'
import { SaleTypeControl } from './controls/SaleTypeControl'
import { FoodModeControl } from './controls/FoodModeControl'
// import { CustomerTypeControl } from './controls/CustomerTypeControl'
// import { EmployeeControl } from './controls/EmployeeControl'
import { MailControl } from './controls/MailControl'
import styles from './FilterControls.module.scss'
import { FilterValues } from '../filterStore/store/types'

const formId = 'average-check-filter'

type Props = React.FormHTMLAttributes<HTMLFormElement> & {
  email?: string | null
  profileLink?: string
  onApply?: (formData: FormData) => void
  pending?: boolean
}

export const FilterControls = ({ email, profileLink, onApply, pending, ...props }: Props) => {
  useEffect(() => {
    filterActions.initialize()
  }, [])

  const visibility = useFilterVisibility()

  const isFilterReady = useFilterReady()

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    const targetFormId = 'id' in e.target ? e.target.id : 'unknown'
    if (targetFormId !== formId) return
    filterActions.apply()
    onApply?.(new FormData(e.currentTarget))
  }

  return (
    <form onSubmit={handleSubmit} id={formId} {...props}>
      <div className={styles.controlsLayout}>
        <div className={styles.column}>
          {visibility.orgTypes && <OrgTypeControl />}
          {visibility.orgs && <OrgControl />}
          {visibility.buildings && <BuildingControl />}
          {visibility.salePoints && <SalePointControl />}
          {/* Отключено, так как пока не нужно */}
          {/*{visibility.customerTypes && <CustomerTypeControl />}
          {visibility.employees && <EmployeeControl />}*/}
        </div>
        <div className={styles.column}>
          {/* Временно скрыто (не используется) {visibility.schoolYears && <SchoolYearControl />} */}
          {visibility.period && <PeriodControl />}
          {visibility.saleTypes && <SaleTypeControl />}
          {visibility.foodModes && <FoodModeControl />}
          {visibility.mail && <MailControl email={email} profileLink={profileLink} />}
        </div>
      </div>

      <ControlsBar className={styles.footer} right>
        <PlainButton disabled={!isFilterReady || pending} type="submit">
          {'Сформировать'}
        </PlainButton>
      </ControlsBar>
    </form>
  )
}
